import type { Nullable } from '~/types'
import type { GetListProfile } from '~/types/rental-api-aliases'

/**
 * Returns collection of basic user details, advanced properties, and
 * helpers.
 *
 * @param user The user to get the details for.
 * @returns The user details.
 */
export function getBookingUser(user?: Nullable<GetListProfile>) {
  // Base properties.
  const userAbout = user?.About ?? ''
  const userAvatar = user?.Avatar ?? ''
  const userCoverImage = user?.CoverImage ?? null
  const userCreatedAt = user?.CreatedAt ?? ''
  const userFirstName = user?.FirstName ?? ''
  const userId = user?.Id ?? 0
  const userIsSuperHostActive = user?.IsSuperHostActive ?? false
  const userIsVerified = user?.IsVerified ?? false
  const userLanguage = user?.Language ?? 'Any'
  const userLastName = user?.LastName ?? ''
  const userLocation = user?.Location ?? null
  const userName = user?.Name ?? ''

  // Advanced `has` checks.
  const userHasCreatedAtDate = userCreatedAt !== ''

  return {
    userAbout,
    userAvatar,
    userCoverImage,
    userCreatedAt,
    userFirstName,
    userId,
    userIsSuperHostActive,
    userIsVerified,
    userLanguage,
    userLastName,
    userLocation,
    userName,

    userHasCreatedAtDate,
  }
}
